// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".maintenance-progress[data-v-f0d6a662]{animation:progress-f0d6a662 3s ease-in-out infinite;width:60%}.image[data-v-f0d6a662]{background-image:url(/images/maintenance.png)}@keyframes progress-f0d6a662{0%,to{width:60%}50%{width:80%}}@media (max-width:768px){.backdrop-blur-sm[data-v-f0d6a662]{backdrop-filter:blur(2px)}}@media (max-width:640px){.container[data-v-f0d6a662]{padding-left:1rem;padding-right:1rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
